import { jsx as _jsx } from "react/jsx-runtime";
import { Field } from "formik";
import { StarRating } from "../../star-rating";
/**
 * A formik field for star rating input.
 *
 * @param {Props} props The props for the component.
 * @returns {JSX.Element} The rendered star rating field component.
 */
export const StarRatingField = ({ name }) => (_jsx(Field, { name: name, children: ({ field, form }) => (_jsx(StarRating, { ...field, onChange: value => {
            const shouldValidate = form.validateOnChange;
            form.setFieldValue(name, value, shouldValidate);
            form.setFieldTouched(name, true);
        } })) }));
